// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item--dense[data-v-05feb588], .v-list--dense .v-list-item[data-v-05feb588] {\n  min-height: 30px !important;\n}\n.v-card__title[data-v-05feb588] {\n  word-break: normal !important;\n  text-align: center;\n}", ""]);
// Exports
module.exports = exports;
